<div class="form-container">
  <div class="advanced-form-container" [class.open]="displayAdvancedForm()">
    <div class="advanced-form">
      <rt-form-field class="invitation-type">
        <div class="invitation-type-label-container">
          <rt-label
            >{{ 'tlc.members.add_member.member_details_form.invite_method.label' | translate }}
          </rt-label>
          <div class="import-csv" (click)="navigateToCsvImport()">
            <rt-icon name="file-account" size="small-x" />
            <span>{{ 'tlc.members.add_member.member_details_form.import_csv' | translate }}</span>
          </div>
        </div>
        <tlc-invite-method-select [inviteMethodControl]="$any(parentForm().get('inviteMethod'))" />
      </rt-form-field>
      <div
        class="username-generation-method-container"
        [class.open]="inviteMethodControl.value === InviteMethod.Login"
        [attr.margin-top]="inviteMethodControl.value === InviteMethod.Login || null"
      >
        <rt-form-field class="username-generation-method">
          <rt-label
            >{{
              'tlc.members.add_member.member_details_form.login_type.dropdown.label' | translate
            }}
          </rt-label>
          <tlc-login-type-select [loginTypeControl]="$any(parentForm().get('loginType'))" />
        </rt-form-field>
      </div>
    </div>
  </div>

  <div
    [formGroup]="parentForm()!"
    class="parent-form-container"
    [attr.margin-top]="displayAdvancedForm() || null"
  >
    <div formArrayName="members">
      @for (item of members; track item.getRawValue()) {
        <div class="details-item" [formGroupName]="$index">
          @if (inviteMethodControl.value === InviteMethod.Email) {
            <rt-form-field [hideRequiredBadge]="!$first" class="email-field">
              @if ($first) {
                <rt-label>{{ 'tlc.members.add_member.form.email' | translate }}</rt-label>
              }
              <rt-input
                [rtFormError]="emailFieldErrors"
                [placeholder]="'tlc.members.add_member.form.email_placeholder' | translate"
                formControlName="email"
                type="email"
                rtProtectedControl
              />
            </rt-form-field>
          }
          <rt-form-field class="first-name">
            @if ($first) {
              <rt-label>{{ 'tlc.members.add_member.form.first_name' | translate }}</rt-label>
            }
            <rt-input
              [placeholder]="'tlc.members.add_member.form.first_name_placeholder' | translate"
              formControlName="firstName"
              rtProtectedControl
            />
          </rt-form-field>
          <rt-form-field class="last-name">
            @if ($first) {
              <rt-label>{{ 'tlc.members.add_member.form.last_name' | translate }}</rt-label>
            }
            <rt-input
              [placeholder]="'tlc.members.add_member.form.last_name_placeholder' | translate"
              formControlName="lastName"
              rtProtectedControl
            />
          </rt-form-field>
          @if (
            inviteMethodControl.value === InviteMethod.Login &&
            loginTypeControl.value === LoginType.Custom
          ) {
            <rt-form-field class="login">
              @if ($first) {
                <rt-label>{{ 'tlc.members.add_member.form.login' | translate }}</rt-label>
              }
              <rt-input
                [placeholder]="'tlc.members.add_member.form.login_placeholder' | translate"
                [rtFormError]="loginFieldErrors"
                formControlName="login"
                rtProtectedControl
              />
            </rt-form-field>
          }
          @if (members.length > 1) {
            <rt-form-field class="remove-button">
              <rt-label />
              <rt-icon-button
                (click)="removeMemberFormGroup($index)"
                iconName="close"
                variant="plain"
                class="remove-form-group-button"
              />
            </rt-form-field>
          }
        </div>

        @if (item.controls.email.getError('existingMember')) {
          <tl-existing-member-info
            [member]="item.controls.email.getError('existingMember')"
            [canEditAccess]="canManageTellentUsers"
            (editAccess)="editAccess($event)"
          />
        }
      }
    </div>
    <div class="add-button-wrap">
      <rt-button
        [disabled]="parentForm().invalid || !canAddRow()"
        (click)="addMemberFormGroup()"
        variant="plain"
      >
        <rt-icon name="add" />
        <span>{{ 'tlc.members.add_member.form.add_next' | translate }}</span>
      </rt-button>
    </div>
  </div>
</div>
